export default {
    connectedFacebookPages(state) {
        return state.connectedFacebookPages;
    },
    connectedFacebookWalls(state) {
        return state.connectedFacebookWalls;
    },
    authUrl(state) {
        return state.authUrl;
    },
    connectedFacebookPagesForSelect(state) {
        const pages = [];
        
        for (const index in state.connectedFacebookPages) {
            const keywordItem = {
                id: state.connectedFacebookPages[index].id,
                text: state.connectedFacebookPages[index].feederName
            }

            pages.push(keywordItem);
        }

        return pages;
    },
    retrievedPages(state){
        return state.retrievedFacebookPages;
    }
}